import type { PropsWithChildren } from 'react';
import React, { forwardRef, useState } from 'react';

import type { InputProps } from '@/core/types/components';

interface RadioInputProps extends InputProps<string>, PropsWithChildren {
  checked?: boolean;
}

const RadioInput = forwardRef<HTMLInputElement, RadioInputProps>(({ id, value, checked, onChange, onBlur, children }, ref) => {
  const [localValue, setLocalValue] = useState<string>(value);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setLocalValue(event.target.value);
    onChange?.(event.target.value);
    onBlur?.(event.target.value);
  };

  return (
    <label htmlFor={id} className="flex-start flex cursor-pointer items-center py-1">
      <input id={id} type="radio" className="sr-only size-6" aria-labelledby={`${id}-span`} checked={checked} value={localValue} onChange={handleChange} ref={ref} />
      <div className="pointer-events-none inline-flex size-6 items-center justify-center" aria-hidden="true">
        {checked === true ? (
          <svg xmlns="http://www.w3.org/2000/svg" className="size-6" viewBox="0 0 24 24" fill="none">
            <g clipPath="url(#clip0_524_12538)">
              <circle cx="12" cy="12" r="11.25" strokeWidth="1.5" className="stroke-content-secondary" />
              <ellipse cx="12.0002" cy="12" rx="6.85714" ry="6.85712" className="fill-content-secondary" />
            </g>
            <defs>
              <clipPath id="clip0_524_12538">
                <rect width="24" height="24" />
              </clipPath>
            </defs>
          </svg>
        ) : (
          <svg xmlns="http://www.w3.org/2000/svg" className="size-6" viewBox="0 0 24 24" fill="none">
            <g clipPath="url(#clip0_524_12536)">
              <circle cx="12" cy="12" r="11.25" strokeWidth="1.5" className="stroke-stroke-secondary" />
            </g>
            <defs>
              <clipPath id="clip0_524_12536">
                <rect width="24" height="24" />
              </clipPath>
            </defs>
          </svg>
        )}
      </div>
      <span id={`${id}-span`} className="text-body-secondary ml-3 w-full select-none space-x-1 text-content-placeholder">
        {children}
      </span>
    </label>
  );
});

export default RadioInput;
